<template>
    <div class="position-relative mem_count_vue mr-2 ">
        <b-spinner v-if="is_load" small label="Small Spinner" variant="danger" type="grow"></b-spinner>
        <span v-else>
                <i class="fal fa-flag-alt"></i>
                <span class="badge badge-icon pos-top pos-right">
                      {{mem_anim_count}}
                </span>
        </span>
    
    </div>
</template>

<script>
    import { TweenLite } from 'greensock';
    export default {
        name: "mem_count",

        props: {
            item: {
                type: Object,
                default: () => {
                }
            },
        },

        created() {
            this.is_load = true;
            EventBus.$on('mem_count_ready',this.setMemCount)
        },
        
        data() {
            return  {
                is_load : false,
                mem_anim_count: 0,
            }
        },

        methods : {
            setMemCount(menus_count) {
                let self = this;
                
                if(menus_count.length > 0) {
                    menus_count.map(menu_item => {
                        let menu_item_id = self.item.id;
                        try {
                            if (self.item.type == 'alias') {
                                menu_item_id = self.item.alias_id;
                            }
                        }
                        catch (e) {
                        
                        }
                        if(parseInt(menu_item.menu_id) === parseInt(menu_item_id)) {
                            this.is_load = false;
                            this.mem_anim_count = parseInt(menu_item.menu_count);
                        }
                    })
                }
            },
        },

     
        computed: {
            animatedNumber: function() {
                return this.mem_anim_count.toFixed(0);
            }
        },
  
        watch : {
            'item.mem_count': function(newValue) {
                TweenLite.to(this.$data, 0.5, { mem_anim_count: newValue });
            }
        },

    }
</script>

<style scoped>
    .mem_count_vue {
        width:25px;

    }


</style>
